var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-6" },
        [
          _c("field-input", {
            attrs: { model: _vm.$v.first_name, "field-name": "First name" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-6" },
        [
          _c("field-input", {
            attrs: { model: _vm.$v.last_name, "field-name": "Last name" },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-6" },
        [
          _c("field-input", {
            attrs: { model: _vm.$v.email, "field-name": "Email" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-md-12 col-lg-6 margin-y-1",
          class: { "has-error": _vm.$v.phone.$error },
        },
        [
          _c("label", { staticClass: "control-label col-sm-4" }, [
            _vm._v(" " + _vm._s(_vm.$phoneFieldName) + ":"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-sm-8",
              staticStyle: { "padding-left": "10px", "padding-right": "0px" },
            },
            [
              _c("vue-tel-input", {
                ref: "phone",
                attrs: {
                  name: "phone",
                  "preferred-countries": ["AU", "GB", "US"],
                  "default-country": _vm.$user.region
                    ? _vm.$user.region.shortname
                    : null,
                  "auto-default-country":
                    _vm.$user.region && _vm.$user.region.shortname
                      ? true
                      : false,
                  "style-classes": _vm.$v.phone.$error
                    ? "red-border form-control"
                    : "form-control",
                },
                scopedSlots: _vm._u([
                  {
                    key: "arrow-icon",
                    fn: function ({ open }) {
                      return [_vm._v(_vm._s(open ? "▲" : "▼"))]
                    },
                  },
                ]),
                model: {
                  value: _vm.$v.phone.$model,
                  callback: function ($$v) {
                    _vm.$set(_vm.$v.phone, "$model", $$v)
                  },
                  expression: "$v.phone.$model",
                },
              }),
              _vm._v(" "),
              _c("vuelidate-help", {
                attrs: { label: "Phone", field: _vm.$v.phone },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }